import { imageLoader } from "@cornerstonejs/core";
import {
  cornerstoneNiftiImageLoader,
  createNiftiImageIdsAndCacheMetadata,
} from "@cornerstonejs/nifti-volume-loader";
import pako from "pako";
const originalFetch = window.fetch;
window.fetch = function (input, init = {}) {
  if (typeof input === "string" && input.includes("/data/")) {
    init.credentials = "include";
  }

  return originalFetch.call(this, input, init);
};

/**
 * Create imageIds for a NIfTI file from a URL.
 *
 * This is the NIfTI counterpart to createImageIdsAndCacheMetaData.
 * It fetches the NIfTI header via streaming, generates one imageId per slice,
 * and caches the metadata so that both stack and volume viewports work.
 *
 * @param niftiUrl - Full URL to the .nii or .nii.gz file
 * @returns imageIds array ready for volume or stack viewports
 */
export default async function createNiftiImageIds(
  niftiUrl: string,
): Promise<string[]> {
  // Ensure the nifti loader is registered (idempotent — safe to call again)
  imageLoader.registerImageLoader("nifti", cornerstoneNiftiImageLoader);

  let finalUrl = niftiUrl;

  if (niftiUrl.endsWith(".nii.gz") || niftiUrl.includes("/nii.gz/")) {
    const resp = await fetch(niftiUrl, { credentials: "include" });
    if (!resp.ok) throw new Error(`Fetch failed: ${resp.status}`);

    const compressed = new Uint8Array(await resp.arrayBuffer());
    const decompressed = pako.inflate(compressed);

    const blob = new Blob([decompressed], { type: "application/octet-stream" });
    finalUrl = URL.createObjectURL(blob);
  }

  const imageIds = await createNiftiImageIdsAndCacheMetadata({ url: finalUrl });
  return imageIds;
}
